import { render, staticRenderFns } from "./AcceptTransferBooking.vue?vue&type=template&id=7b5b32a0&"
import script from "./AcceptTransferBooking.vue?vue&type=script&setup=true&lang=js&"
export * from "./AcceptTransferBooking.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports